<template>
  <div>
    <template v-if="isTags">
      <Tooltip placement="left">
      {{ tag | getFirstTag }}
      <Icon type="ios-eye" />
      <div slot="content">
        <div v-html="$util.listTag(tag)"></div>
      </div>
    </Tooltip>
    </template>
    <template v-else>
      <div>
        {{ tag }}
      </div>
    </template>

  </div>
</template>

<script>
export default {
  name: "TagList",
  props: ["tag"],
  computed: {
    isTags() {
        // if(tag.split(";").length > 0){

        // }
        if(typeof this.tag === "string"){
          if(this.tag.includes(";")){
            return this.tag.split(";").length > 0
          } else {
            if(this.tag.includes(",")){
            return this.tag.split(",").length > 0
          }
          }
        }
    },

  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/tagList.vue